<template>
  <u-button
    variant="outline"
    icon="i-ri-qr-code-line"
    @click="openQRCodeModal"
    label="QR Code"
  />
</template>

<script setup>
  import {CoreQrCodeModal} from '#components';

  const props = defineProps({
    filename: {
      type: String,
      default: 'share'
    },
    url: {
      type: String,
      required: true
    }
  })

  function openQRCodeModal() {
    useFModal({
      id: 'dl-qrcode',
      component: CoreQrCodeModal,
      showClose: false,
      size: 'xs',
      props: {
        filename: props.filename,
        url: props.url
      }
    }).open();
  }
</script>
